import { render, staticRenderFns } from "./onlineRegistrationV2.vue?vue&type=template&id=4cacd417&scoped=true&"
import script from "./onlineRegistrationV2.vue?vue&type=script&lang=js&"
export * from "./onlineRegistrationV2.vue?vue&type=script&lang=js&"
import style0 from "./onlineRegistrationV2.vue?vue&type=style&index=0&id=4cacd417&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cacd417",
  null
  
)

export default component.exports